import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import { LinkComponent } from '~/_shared/baseComponents/links';
import { useTranslation } from '~/_shared/utils/hooks';
import { convertNumberToLetters } from '~/_shared/utils/text/text.helpers';
import {
  listingItemIconStyle, listingItemSecondaryTitleStyle, listingNumberStyle, SecondaryListingItem,
} from '~/map/dropdown/mapDropdown.styles';
import type { MapListingRowItem } from '~/map/listing/tableData/mapRow/mapRow.component';
import { getMapRowIcon } from '~/map/listing/tableData/mapRow/mapRow.helpers';
import {
  compareIdToParentMapOrMapId, getMapUrl,
} from '~/map/map.helpers';
import { useMapInfoDataSelector } from '~/store/mapInfo/mapInfo.selectors';

type MapDropdownSubItemProps = {
  index: number;
  isSnapshot: boolean;
  item: MapListingRowItem;
  onListingItemClick: () => void;
};

export const MapDropdownSubItemComponent = ({
  index,
  item,
  isSnapshot,
  onListingItemClick,
}: MapDropdownSubItemProps) => {
  const [t] = useTranslation();
  const mapInfo = useMapInfoDataSelector();
  const noAccess = item.noAccess;
  const isHighlighted = !isSnapshot && compareIdToParentMapOrMapId(item.id, mapInfo);

  return (
    <SecondaryListingItem>
      <LinkComponent
        css={listingItemSecondaryTitleStyle(isHighlighted)}
        disabled={noAccess}
        onClick={onListingItemClick}
        path={getMapUrl(item.id)}
        tooltip={noAccess ? t('map.noAccess') : undefined}
      >
        <span css={listingNumberStyle}>
          {convertNumberToLetters(index + 1)}.
        </span>
        <span css={listingItemIconStyle(isHighlighted)}>
          <FontAwesomeIcon
            icon={getMapRowIcon({ isSnapshot, item })}
          />
        </span>
        {item.name}
      </LinkComponent>
    </SecondaryListingItem>
  );
};
